/****************************************************
 * Module Name:  TenderCompanyProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class TenderCompanyProxy {

    static GetAllCompanies = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tendercompany",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleCompany = (companyId, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/tendercompany/${companyId}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
    static GetCompanyMini = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tendercompany/mini",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CheckCompanyNameAvailable = (name, callback) => {
        let params = {
            name: name,
        };

        restAPICall(
            Constants.MANAGER_URL + "/tendercompany/available",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddCompany = (company, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tendercompany",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(company),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateCompany = (company, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tendercompany",
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(company),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddCompanyLogo = (id, data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/tendercompany/upload/${id}`,
            "post",
            Constants.userToken,
            undefined,
            data,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static RemoveCompanyLogo = (id, data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/tendercompany/upload/${id}`,
            "delete",
            Constants.userToken,
            undefined,
            data,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}